import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';

import AppBar from 'components/AppBar';
import ApplicationOverlayContent from 'components/ApplicationLayout/ApplicationOverlayContent';
import { Desktop, Mobile } from 'components/Responsive';
import ScreenHeader from 'components/ScreenHeader';
import useStoreTranslation from 'hooks/useStoreTranslation';

import {
  Container,
  Header,
  Subheader,
  Checkbox,
  TermsContainer,
  TermsTitle,
  BackButton,
  NextButton,
  ButtonsContainer,
  ButtonLine,
} from '../../../styles';
import { CountryValues } from '../../Country';
import Privacy from '../documents/privacy';
import Terms from '../documents/terms';
import { DocumentTextContainer } from '../styles';

import { CompanyValues } from '..';

interface Props {
  company: CompanyValues | null;
  onSubmit: () => void;
  country?: CountryValues | null;
}

const Continue = ({ company, onSubmit, country }: Props) => {
  const { t } = useStoreTranslation();
  const history = useHistory();

  const [termsChecked, setTermsChecked] = useState(company !== null);
  const [privacyChecked, setPrivacyChecked] = useState(company !== null);

  const [showTerms, setShowTerms] = useState(false);
  const [showPrivacy, setShowPrivacy] = useState(false);

  const openTerms = () => setShowTerms(true);
  const closeTerms = () => setShowTerms(false);

  const openPrivacy = () => setShowPrivacy(true);
  const closePrivacy = () => setShowPrivacy(false);

  const handleToggleTerms = () => setTermsChecked((terms) => !terms);
  const handleTogglePrivacy = () => setPrivacyChecked((privacy) => !privacy);

  const handleBack = () => history.goBack();

  return (
    <>
      <Container>
        <Header>{t('registrationOnboarding.company.continue.title')}</Header>
        <Subheader>{t('registrationOnboarding.company.continue.subtitle')}</Subheader>

        <TermsContainer>
          <TermsTitle>{t('registrationOnboarding.company.acceptTerms.title')}</TermsTitle>
          <Checkbox checked={termsChecked} onChange={handleToggleTerms} circle size={24}>
            <div id="terms">
              &nbsp;{' '}
              <a
                href="https://reservas.netactica.com/corporate/terminos_condiciones_v2.pdf"
                target="_blank"
                rel="noreferrer"
              >
                {t('registrationOnboarding.company.acceptTerms.terms')}
              </a>
            </div>
          </Checkbox>

          <Checkbox checked={privacyChecked} onChange={handleTogglePrivacy} circle size={24}>
            <div id="terms">
              &nbsp;{' '}
              <a
                href="https://reservas.netactica.com/corporate/terminos_condiciones_v2.pdf"
                target="_blank"
                rel="noreferrer"
              >
                {t('registrationOnboarding.company.acceptTerms.privacy')}
              </a>
            </div>
          </Checkbox>
        </TermsContainer>

        <ButtonsContainer>
          <ButtonLine>
            <BackButton type="button" onClick={handleBack}>
              {t('registrationOnboarding.backButton')}
            </BackButton>
            <NextButton disabled={!termsChecked || !privacyChecked} onClick={onSubmit}>
              {t('registrationOnboarding.nextButton')}
            </NextButton>
          </ButtonLine>
        </ButtonsContainer>
      </Container>

      <ApplicationOverlayContent sidebar onClose={closeTerms} width={1000} show={showTerms}>
        <>
          <Mobile>
            <AppBar noGoBack rightIcon="/corporate/images/close.svg" rightAction={closeTerms}>
              {t('registrationOnboarding.company.termsTitle')}
            </AppBar>
          </Mobile>
          <Desktop>
            <ScreenHeader title={t('registrationOnboarding.company.termsTitle')} />
          </Desktop>
          <DocumentTextContainer>
            <Terms country={country?.country.id} />
          </DocumentTextContainer>
        </>
      </ApplicationOverlayContent>

      <ApplicationOverlayContent sidebar onClose={closePrivacy} width={1000} show={showPrivacy}>
        <>
          <Mobile>
            <AppBar noGoBack rightIcon="/corporate/images/close.svg" rightAction={closePrivacy}>
              {t('registrationOnboarding.company.privacyTitle')}
            </AppBar>
          </Mobile>
          <Desktop>
            <ScreenHeader title={t('registrationOnboarding.company.privacyTitle')} />
          </Desktop>
          <DocumentTextContainer>
            <Privacy country={country?.country.id} />
          </DocumentTextContainer>
        </>
      </ApplicationOverlayContent>
    </>
  );
};

export default Continue;
